import { Text, UnstyledButton } from '@mantine/core';
import classes from './GoalsStep.module.css';

interface ChoiceButtonProps {
  label: string;
  description?: string;
  disabled?: boolean;
  onClick: () => void;
}

/** A full-width option card used in the Add-a-goal and Add-a-requirement modals. */
export function ChoiceButton({
  label,
  description,
  disabled,
  onClick,
}: ChoiceButtonProps) {
  return (
    <UnstyledButton
      className={classes.choice}
      disabled={disabled}
      onClick={onClick}
    >
      <Text fw={600}>{label}</Text>
      {description && (
        <Text size="sm" c="dimmed" mt={2}>
          {description}
        </Text>
      )}
    </UnstyledButton>
  );
}
